import useRemove from "@/hooks/use-remove";
import { UseLoadingReturn } from "@/hooks/use-loading";
import closedDaysService from "@/services/closed-days.service";
import { RequestsProps } from "@/types/requests.types";

export type Props = {
  _id: number;
} & RequestsProps;

export type Return = {
  remove: (props: Props) => Promise<void>;
} & UseLoadingReturn;

const useRemoveClosedDays = (): Return => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (_id) => closedDaysService.delete(_id),
  });

  return { isLoading, startLoading, endLoading, loadingIcon, remove };
};

export default useRemoveClosedDays;
